var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');

var PostListHeader = createReactClass({
	categorySlug2Header: {
		'expert-opinions': (
			<div className="post-list-header row">
				<Helmet
					title="Digestive System Articles | MHealth News &amp; Opinion"
					meta={[
						{"property": "description", "content": "Our doctors and experts weigh-in on digital & mobile health news, with articles about the digestive system, GI issues, and more."}
					]}
				/>
                <div className="column">
                    <h2>Expert Opinions</h2>
                    <p>Commentaries about digestive and digital health from the MyGiHealth team</p>
                </div>
            </div>
		),
		'news-updates': (
			<div className="post-list-header row">
				<Helmet
                  title="News &amp; Updates | MyGiHealth &amp; My Total Health"
                  titleTemplate = "%s" />
                <div className="column">
                    <h2>News &amp; Updates</h2>
                    <p>Recent articles and press reports from the MyGiHealth team</p>
                </div>
            </div>
		)
	},

	render: function () {
        return this.categorySlug2Header[this.props.categorySlug] || null;
    }
});

module.exports = PostListHeader;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/layout/postListHeader.jsx